import { CidadesEstado, estadosV2, getCidadesByUf } from '@acme/common'
import { Grid, MenuItem } from '@mui/material'
import dayjs from 'dayjs'
import {
    FormField,
    FormFieldAutocomplete,
    FormFieldCheckbox,
} from 'global/components/Form'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import {
    CreateFeriadoInput,
    createFeriadoSchema,
    feriadosCliente,
} from 'service/api'
import { toast } from 'sonner'

export default function AdicionarFeriadoModal() {
    const {
        decoded: { cliente: clienteId },
    } = useAuth()
    const navigate = useNavigate()
    const [cidades, setCidades] = useState<CidadesEstado[]>([])

    const { mutate } = feriadosCliente.mutations.useCreate({
        invalidateQuery: true,
    })

    const handleClickUf = (uf: string) => async () => {
        const cidades = await getCidadesByUf(uf)
        setCidades(cidades)
    }

    const handleClose = () => navigate(-1)

    const handleSubmit: SubmitHandler<CreateFeriadoInput> = ({
        data,
        Cidade,
        repetir,
        ...rest
    }) => {
        data = new Date(
            data.getTime() + Math.abs(data.getTimezoneOffset() * 60000),
        )

        mutate(
            {
                ...rest,
                ...Cidade,
                clienteId,
                mes: Number(dayjs(data).format('MM')),
                dia: Number(dayjs(data).format('DD')),
                ano: repetir ? null : Number(dayjs(data).format('YYYY')),
            },
            {
                onSuccess: () => {
                    toast.success('Feriado cadastrado com sucesso!')
                    handleClose()
                },
                onError: () => {
                    toast.error('Erro ao cadastrar o feriado!')
                },
            },
        )
    }

    return (
        <Dialog.Root
            open={hasPermission(['create', 'Feriados'])}
            height="fit-content"
            width="36rem"
            onSubmit={handleSubmit}
            schema={createFeriadoSchema}
        >
            <Dialog.Title>Cadastrar feriado</Dialog.Title>
            <Dialog.Content dividers>
                <Grid container spacing={1} columnSpacing={2} mb={1}>
                    <Grid item xs={12}>
                        <FormField
                            name="nome"
                            label="Nome do Feriado"
                            required
                            autoComplete="off"
                        />
                    </Grid>
                    <Grid item xs={7}>
                        <FormField
                            name="data"
                            label="Data"
                            required
                            type="date"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={5}
                        sx={{
                            height: 'max-content',
                            marginTop: '0.5rem',
                        }}
                    >
                        <FormFieldCheckbox
                            name="repetir"
                            label="Repetir todos os anos"
                            defaultChecked={true}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <FormField name="uf" label="UF" required select>
                            {estadosV2.map(({ sigla }) => (
                                <MenuItem
                                    key={sigla}
                                    value={sigla}
                                    onClick={handleClickUf(sigla)}
                                >
                                    {sigla}
                                </MenuItem>
                            ))}
                        </FormField>
                    </Grid>
                    <Grid item xs={9}>
                        <FormFieldAutocomplete
                            name="Cidade"
                            label="Cidade"
                            options={cidades.map(cidade => ({
                                cidade: cidade.nome,
                                ibge: cidade.id,
                            }))}
                            required
                            getOptionLabel={option => option.cidade}
                        />
                    </Grid>
                </Grid>
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
